import { ActionButtonProps, Box, BoxProps, ButtonProps, Form, ModBox, Spacer, Text, TextProps } from '@jfs/ui-new'
import { Button } from '../../components/AdminButton'
import { useCallback, useEffect, useState } from 'react'
import { Container } from '../../components/Container'
import { NewTable } from '../../components/NewTable'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { PAYMENT_MODE_SUBTYPES } from '../../utils/constants'
import { GetFormdata } from './formData'

const initialValues = {
  processingEntity: '',
  methodSubType: '',
  methodType: '',
  bankId: '',
  cardType: '',
  cardScheme: '',
}

const checkerHeaderTitles = {
  editable: 'Select',
  bankId: 'Bank Id',
  processingEntity: 'Processing Entity',
  failureRate: 'Failure Rate',
  lastTxnDate: 'Last Txn Date',
  resetAfter: 'Reset After',
  plannedDowntimeStartAt: 'Start Datetime',
  plannedDowntimeEndAt: 'End Datetime',
}

export const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    bankId: 50,
    processingEntity: 80,
    editable: 30,
    failureRate: 50,
    lastTxnDate: 150,
    resetAfter: 50,
    plannedDowntimeStartAt: 150,
    plannedDowntimeEndAt: 150,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

const DynamicRouting = () => {
  const {
    undateEnableDynamicRouting,
    getPaymentsInstrumentsList,
    fetchDynamicConfig,
    dynamicConfigList,
    toggleConfigListCheck,
    saveConfigDataChange,
    updateDynamicRouteConfig,
    resetDynamicConfigList,
    clearDynamicConfigList,
    accessConfig,
  } = useStores((store) => ({
    undateEnableDynamicRouting: store.routingRule.undateEnableDynamicRouting,
    getPaymentsInstrumentsList: store.routingRule.getPaymentsInstrumentsList,
    fetchDynamicConfig: store.routingRule.fetchDynamicRouteConfig,
    dynamicConfigList: store.routingRule.getDynamicConfigList(),
    toggleConfigListCheck: store.routingRule.toggleConfigListCheck,
    saveConfigDataChange: store.routingRule.saveConfigDataChange,
    updateDynamicRouteConfig: store.routingRule.updateDynamicRouteConfig,
    resetDynamicConfigList: store.routingRule.resetDynamicConfigList,
    clearDynamicConfigList: store.routingRule.clearDynamicConfigList,
    accessConfig: store.user.getAccessConfig(['routing', 'dynamic_routing']),
  }))
  console.log('dynamicConfigList', dynamicConfigList)
  const [dynamicRoutingStatus, setDynamicRoutingStatus] = useState({ enabled: false, disabled: false })
  const [selectedInstrument, setSelectedInstrument] = useState('')
  const [cardType, setCardType] = useState('')

  const [lazyGetPaymentsInstrumentsApi, paymentsConfigListStateHandler] = useLazyApiData(getPaymentsInstrumentsList)
  const [fetchDynamicConfigApi, fetchDynamicConfigApiHandler] = useLazyApiData(fetchDynamicConfig)
  const [lazyUpdateDynamicRouteConfig, updateDynamicRouteConfigHadler] = useLazyApiData(updateDynamicRouteConfig)

  const loadInitials = useCallback(
    () => lazyGetPaymentsInstrumentsApi([PAYMENT_MODE_SUBTYPES.NB, PAYMENT_MODE_SUBTYPES.WALLET]),
    [lazyGetPaymentsInstrumentsApi],
  )

  useEffect(() => {
    loadInitials()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => clearDynamicConfigList()
  }, [])

  const activateDeactivateDynamicRouting = async (status: boolean) => {
    await undateEnableDynamicRouting(status).catch((err) => {
      console.log('error while calling enable dynamic routing api', err)
    })
    // if (response?.recordStatus === 'SUCCESS') {
    //  setDynamicRoutingStatus(finalState)
    //}
  }

  const onChangeInput = (data) => {
    saveConfigDataChange(data)
  }

  const onItemChecked = (checked, index, rowdata) => {
    console.log('checked, index, rowdata', checked, index, rowdata)
    toggleConfigListCheck(rowdata.id)
  }

  const onSearch = (data: any) => {
    console.log(data)
    fetchDynamicConfigApi(data)
  }
  const handleActions = (props: ActionButtonProps) => {
    console.log(props)
    const { values, title, defaultActionButtonOnSubmit, isCurrentFormValid } = props

    setSelectedInstrument(values?.methodSubType)
    setCardType(values?.cardType)
    const handleOnPress = (props2) => {
      console.log(props2)
      defaultActionButtonOnSubmit()
    }
    return (
      <Box ph={10}>
        <Button
          isLoading={fetchDynamicConfigApiHandler.state === 'pending'}
          title={title}
          onPress={handleOnPress}
          height={40}
          disabled={!isCurrentFormValid}
          color={'#214796'}
        />
      </Box>
    )
  }

  return (
    <Container
      isLoading={paymentsConfigListStateHandler.state === 'pending'}
      errorMessage={paymentsConfigListStateHandler?.data?.message}
      onRetry={loadInitials}>
      <Box height={'100%'}>
        <ModBox {...styles.container} show={isAccessible(accessConfig, 'edit')}>
          <Text {...styles.headerStyle}>{'Dynamic Routing'}</Text>
          <Spacer size={60} direction="horizontal" />
          <Button
            title={'Enable All'}
            type={'primary'}
            {...styles.button}
            onPress={async () => await activateDeactivateDynamicRouting(true)}
          />
          <Spacer size={40} direction="horizontal" />
          <Button
            title={'Disable All'}
            type={'primary'}
            {...styles.button}
            onPress={async () => await activateDeactivateDynamicRouting(false)}
          />
        </ModBox>

        <Spacer size={20} direction="vertical" />

        <Form
          formData={GetFormdata(onSearch, selectedInstrument, cardType)}
          actionButtons={handleActions}
          initialValues={initialValues}
          container={FormBox}
        />
        <Spacer size={20} direction="vertical" />
        <ModBox show={dynamicConfigList?.length > 0} flex={1}>
          <Box flex={1} backgroundColor={'BG_PRIMARY'} minHeight={250}>
            <NewTable
              data={dynamicConfigList}
              rowHeight={48}
              headerHeight={64}
              customWidthFunc={getCustomColumnWidth}
              // tableWidth={width > 1200 ? width - 290 : width}
              headerRowKeys={checkerHeaderTitles}
              onRowClick={() => console.log('row clicked')}
              onRowEditClicked={onItemChecked}
              // rowsChecked={rowsChecked}
              onChangeInput={onChangeInput}
              freezeColumn={'selected'}
              freezeColumnWidth={50}
              onAction={() => console.log('row clicked')}
            />
          </Box>
          <ModBox ph={10} flexDirection="row" pt={10} show={isAccessible(accessConfig, 'edit')}>
            <Button
              title={'Update Data'}
              onPress={() => lazyUpdateDynamicRouteConfig()}
              height={40}
              isLoading={updateDynamicRouteConfigHadler.state === 'pending'}
              type="primary"
              color={'#214796'}
            />
            <Spacer size={10} direction="horizontal" />
            <Button
              title={'Reset'}
              onPress={() => resetDynamicConfigList()}
              height={40}
              type="secondary"
              color={'DISABLED_GREY'}
            />
          </ModBox>
        </ModBox>
      </Box>
    </Container>
  )
}

const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}

const styles = {
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  } as BoxProps,
  headerStyle: {
    fontSize: 16,
    color: 'BLACK_75',
    fontWeight: '800',
  } as TextProps,
  button: {
    height: 36,
    width: 120,
  } as ButtonProps,
}
export default DynamicRouting
